module.exports = __webpack_public_path__ + "static/media/logSatteliteActive.ecb08ccd.svg";